import React from 'react';
import { CleaveInput, MaskedInputProps } from '../cleave-input';

export const MaskedSwedishSsnInput = (props: MaskedInputProps) => (
  <CleaveInput options={{ delimiter: '-', blocks: [6, 4] }} {...props} />
);
